// extracted by mini-css-extract-plugin
export default {"maximize":"styles_maximize__wOv5T","maxButton":"styles_maxButton__pZiB-","paused":"styles_paused__mFbt9"};